import { api } from '~/configs/api';

import type {
  CreateActivityParams,
  CreateActivityResponse,
  GetActivityListOptionsResponse,
} from './activityApi.types';

const GET_ACTIVITY_LIST_OPTIONS_ENDPOINT =
  'activity/activity-records/list/options/';
const CREATE_ACTIVITY_ENDPOINT = 'activity/activity-records?';

let activityListOptionsCache: GetActivityListOptionsResponse | null = null;
let activityListOptionsPromise: Promise<GetActivityListOptionsResponse> | null =
  null;

export const fetchActivityListOptions = async () => {
  if (activityListOptionsCache) {
    return activityListOptionsCache;
  }

  if (!activityListOptionsPromise) {
    activityListOptionsPromise = api
      .get<GetActivityListOptionsResponse>(GET_ACTIVITY_LIST_OPTIONS_ENDPOINT)
      .then(({ data }) => {
        activityListOptionsCache = data;
        return data;
      })
      .finally(() => {
        activityListOptionsPromise = null;
      });
  }

  return activityListOptionsPromise;
};

export const createActivity = async (params: CreateActivityParams) => {
  const { data } = await api.post<CreateActivityResponse>(
    CREATE_ACTIVITY_ENDPOINT,
    params
  );

  return data;
};
